import React, {Component} from 'react';
import DisplayBox from '../../hoc/DisplayBox/DisplayBox';
import Button from '../../UI/Button/Button';
import Input from '../../UI/Input/Input';
import classes from './PortalForm.css';
import Message from '../../components/Message/Message';
import Spinner from '../../UI/Spinner/Spinner';
import { checkValidity } from '../../shared/utility';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import MemberInfo from '../../components/MemberInfo/MemberInfo';
import SdkPortalForm from './SdkPortalForm';
import { getTargetUrlDropDownSortedList } from '../../shared/utility';
import { ADD_ELIGIBILITY, AUTO_COMPLETE_SELECT_ENABLE } from '../../shared/Constants';



export class DynamicPortalForm extends Component {

    state = {
        portalForm: {
            targetPortal: {
                elementType: AUTO_COMPLETE_SELECT_ENABLE ? 'autocompleteselect' : 'select',
                elementConfig: {
                    type: 'text',
                    id: 'targetPortal',
                    placeholder: 'Select One',
                    options: getTargetUrlDropDownSortedList(this.props.portalsList, ADD_ELIGIBILITY, this.props.disabledPortals),
                    cssProperties: {
                      width: "140%",
                      left: "-20%",
                    },
                },
                value: this.props.selectedPortal?this.props.selectedPortal.portalShortName:'',
                validation: {
                    required: false
                },
                disabled: false,
                valid: true,
                touched: false,
                label: "Target Portal",
                inputType: "ExtendedInput"
            },
            FirstName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'firstName',
                    placeholder: 'first name',
                    maxLength: 41
                },
                value: '',
                validation: {
                    required: false,
                    maxlength: 40,
                    specialchar: ['<','"','+',':',';','=','\\','*','&','(',')','#', ',']
                },
                disabled: true,
                valid: false,
                touched: false,
                label: "First Name",
                inputType: "OneThird"
            },
            LastName: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'lastName',
                    placeholder: 'last name',
                    maxLength: 41
                },
                value: '',
                validation: {
                    required: false,
                    maxlength: 40,
                    specialchar: ['<','"','+',':',';','=','\\','*','&','(',')','#', ',']
                },
                disabled: true,
                valid: false,
                touched: false,
                label: "Last Name",
                inputType: "OneThird"
            },
            DOB: {
                elementType: 'input',
                elementConfig: {
                    type: 'date',
                    id: 'dob',
                    placeholder: 'mm/dd/yyyy',
                    min: '1900-01-01'
                },
                value: '',
                validation: {
                    required: false,
                    restrictFuture: true,
                    restrictLowerDate: true
                },
                disabled: true,
                valid: false,
                touched: false,
                label: "DOB",
                inputType: "OneThird"
            },
           Gender: {
                elementType: 'select',
                elementConfig: {
                    type: 'text',
                    id: 'gender',
                    placeholder: 'Select One',
                    options: [
                        { value: 'M', displayValue: 'M' },
                        { value: 'F', displayValue: 'F' },
                        { value: 'U', displayValue: 'U' }
                    ]
                },
                value: '',
                validation: {
                    required: false
                },
                disabled: true,
                valid: false,
                touched: false,
                label: "Gender",
                inputType: "OneThird"
            },
            Address_1: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'address1',
                    maxlength: 100
                },
                value: '',
                validation: {
                    required: false
                },
                disabled: true,
                valid: false,
                touched: false,
                label: "Address 1",
                inputType: "OneThird"
            },
            Address_2: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'address2',
                    maxlength: 100
                },
                value: '',
                validation: {
                    required: false,
                },
                disabled: true,
                valid: false,
                touched: false,
                label: "Address 2",
                inputType: "OneThird"
            },
            City: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'city',
                    maxlength: 50
                },
                value: '',
                validation: {
                    required: false
                },
                disabled: true,
                valid: false,
                touched: false,
                label: "City",
                inputType: "OneThird"
            },
            State: {
                elementType: 'select',
                elementConfig: {
                    type: 'select',
                    id: 'state',
                    placeholder: 'Select One',
                    options: []
                },
                value: '',
                validation: {
                    required: false
                },
                disabled: true,
                valid: false,
                touched: false,
                label: "State",
                inputType: "OneThird"
            },
            ZipCode: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'zipCode',
                    minLength: 5,
                    maxLength: 5,
                    pattern: '[0-9]{1,5}',
                    title:'Zip can only contain numbers'
                },
                value: '',
                validation: {
                    required: false,
                    minlength: 5,
                    maxlength: 5
                },
                disabled: true,
                valid: false,
                touched: false,
                label: "Zip Code",
                inputType: "OneThird"
            },
            SSN: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'ssn',
                    minLength: 9,
                    maxLength: 9,
                    pattern: '[0-9]{1,9}',
                    title:'SSN can only contain numbers'
                },
                value: '',
                validation: {
                    required: false,
                    minlength: 9,
                    maxlength: 9
                },
                disabled: true,
                valid: false,
                touched: false,
                label: "Social Security Number",
                inputType: "OneThird"
            },
            GroupId: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'groupId'
                },
                value: '',
                validation: {
                    required: false,
                    maxlength: 30
                },
                disabled: true,
                valid: false,
                touched: false,
                label: "Policy/Group Number",
                inputType: "OneThird"
            },
            SubscriberId: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'subscriberId',
                    minLength: 2,
                    maxLength: 21,
                    pattern: '[a-zA-Z0-9]{1,30}',
                    title: 'Invalid alpha-numeric characters'
                },
                value: '',
                validation: {
                    required: false,
                    minlength: 2,
                    maxlength: 21
                },
                disabled: true,
                valid: false,
                touched: false,
                label: "Subscriber Id",
                inputType: "OneThird"
            },
            MemberId: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'memberId',
                    minLength: 2,
                    maxLength: 21,
                    pattern: '[a-zA-Z0-9]{1,30}',
                    title: 'Invalid alpha-numeric characters'
                },
                value: '',
                validation: {
                    required: false,
                    minlength: 2,
                    maxlength: 21
                },
                disabled: true,
                valid: false,
                touched: false,
                label: "Member Id",
                inputType: "OneThird"
            },
            UUID: {
                elementType: 'input',
                elementConfig: {
                    type: 'text',
                    id: 'uuid'
                },
                value: '',
                validation: {
                    required: false
                },
                disabled: true,
                valid: true,
                touched: false,
                label: "UUID (optional)",
                inputType: "Half"
            }
        },
        formIsValid: false,
        message: null,
        portalSpecificForm: null,
        isSDKPortal:false,
        isPePortal: false
    }

    componentDidMount () {
        // console.log("[Portal Form] componentDidMount");
        if(!this.props.statesList || !this.props.statesList.length > 0) {
            this.props.fetchStates();
        }

        const portalSpecificForm = this.buildPortalForm(this.props.selectedPortal);
        this.setState({portalSpecificForm: portalSpecificForm, isSDKPortal: this.props.selectedPortal?.isSdkPortal,
                        isPePortal: this.props.selectedPortal?.isPePortal});

        if (this.props.memberInfo && this.props.memberInfo.memberPortalAttributeList && this.props.selectedPortal) {
            const modifyEligPortal = this.props.memberInfo.memberPortalAttributeList.filter(x => x.portalShortNm === this.props.selectedPortal.portalShortName);
            this.props.setModifyEligibilityPortal(modifyEligPortal);
        }else{
            this.props.setModifyEligibilityPortal(null);            
        }
    }

    // build form for selected portal, toggle enable/disbale between Subs Id an SSN for CAP, check field validation
    inputChangedHandler = (event, inputIdentifier) => {

        let updatedForm = this.state.portalSpecificForm?{...this.state.portalSpecificForm}:{...this.state.portalForm};
        let selectedPortal = this.props.selectedPortal;
        let isSDKPortal = this.state.isSDKPortal;
        let isPePortal = this.state.isPePortal;
        let targetValue = event.target.value;
        // build a new form for the selected portal portal
        if(inputIdentifier === 'targetPortal'){
            selectedPortal = this.props.portalsInfo[targetValue];
            if (!selectedPortal) {
                return;
            }
            isSDKPortal = selectedPortal.isSdkPortal;
            isPePortal = selectedPortal.isPePortal;

            this.props.portalSelectHandler(selectedPortal);
            if(!(isSDKPortal || isPePortal)){
                updatedForm = this.buildPortalForm(selectedPortal);
            }
            this.props.isSdkPortal(isSDKPortal, isPePortal);

            if (this.props.memberInfo && this.props.memberInfo.memberPortalAttributeList) {
                let modifyEligPortalIndex = null;
                for(let x in this.props.memberInfo.memberPortalAttributeList){
                    if(this.props.memberInfo.memberPortalAttributeList[x].portalShortNm === "BRIOVA" && selectedPortal.portalShortName === "OSP"){  
                                modifyEligPortalIndex = x;
                    }
                    else if(this.props.memberInfo.memberPortalAttributeList[x].portalShortNm === selectedPortal.portalShortName){
                        modifyEligPortalIndex = x;
                    }
                }
                const modifyEligPortal = modifyEligPortalIndex?[this.props.memberInfo.memberPortalAttributeList[modifyEligPortalIndex]]:null;
                this.props.setModifyEligibilityPortal(modifyEligPortal);
            }
        }

        const updatedFormElement = { ...updatedForm[inputIdentifier] };
        updatedFormElement.value = targetValue;

        if(inputIdentifier !== 'targetPortal' && selectedPortal.portalShortName === "CAP") {
            let updatedElement, key = inputIdentifier==="SSN"? "SubscriberId": "SSN";

            if((inputIdentifier === "SSN" || inputIdentifier === "SubscriberId")  && targetValue!=="" && updatedForm[key].value==="") {
                updatedElement = { ...updatedForm[key], disabled: true, valid: true };
            } else {
                updatedElement = { ...updatedForm[key], disabled: false, valid: false };
            }
            updatedForm[key] = updatedElement;
        }

        if(targetValue) {
            const validation = checkValidity(updatedFormElement.value, updatedFormElement.validation);
            updatedFormElement.valid = validation.isValid;
            if(validation.isValid) { this.props.displayMessageHandler(null); }
            else if (validation.message) { this.props.displayMessageHandler({type: "Error", info: {message:validation.message}}); }
        } else {
            updatedFormElement.valid = true;
            this.props.displayMessageHandler(null);
        }

        updatedFormElement.touched = true;
        updatedForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for (let inputIdentifier in updatedForm) {
            formIsValid = (this.props.selectedPortal &&
                (this.props.selectedPortal.portalShortName === 'MYUHC' || (this.props.selectedPortal.portalBrandName && this.props.selectedPortal.portalBrandName === 'MYUHC')) &&
                    inputIdentifier ==='ZipCode' && (updatedForm[inputIdentifier].value==="" || updatedForm[inputIdentifier].value=== undefined)) ?
                        true : updatedForm[inputIdentifier].valid && formIsValid;
        }

        this.setState({portalSpecificForm: updatedForm, formIsValid: formIsValid, isSDKPortal: isSDKPortal, isPePortal: isPePortal });
    }

    buildPortalForm = (selectedPortal, inputValue) => {

        // console.log("[Portal Form] buildForm start ", selectedPortal, this.state.portalForm);
        let form1 = {};
        // let selectedPortal = this.props.portalsInfo[portalId];
        // console.log("[Portal Form] buildForm start ", selectedPortal, this.props.portalsInfo, this.state.portalSpecificForm);

        // Only for modify Eligibility Portal Logic
        if(this.props.modifyEligPortal) {
            const portalSelect = Object.entries(this.props.portalsInfo).find(x => (x[1].parentPortalId && x[1].portalBrandName ? x[1].portalBrandName : x[1].portalShortName) === this.props.modifyEligPortal.portalShortNm);
            selectedPortal = portalSelect[1];
            this.props.portalSelectHandler(selectedPortal);
        }
        if (selectedPortal && selectedPortal.isSdkPortal) {
            return this.state.portalForm;
        }

        // console.log("[Portal Form] buildForm start ", selectedPortal, this.state.portalForm, this.state.portalSpecificForm);

        for (let key in this.state.portalForm) {
            if (key === 'targetPortal' || (selectedPortal && selectedPortal.validElems && selectedPortal.validElems[key] && selectedPortal.validElems[key].isEnabled)) {
                form1[key] = {
                    ...this.state.portalForm[key],
                    disabled: false,
                    value: this.state.portalSpecificForm && this.state.portalSpecificForm[key] ? this.state.portalSpecificForm[key].value : this.state.portalForm[key].value,
                    validation: {
                        ...this.state.portalForm[key].validation,
                        required: true
                    }
                };

                if (selectedPortal && key === 'GroupId') {

                    if(selectedPortal.prtlPolNbr) {
                        // console.log("Group ID --->",this.props.selectedPortal, this.props.selectedPortal.prtlPolNbr);
                        form1[key] = {
                            ...form1[key],
                            value: selectedPortal.prtlPolNbr,
                            disabled: true,
                            valid: true
                        };
                    } else {
                        form1[key] = {
                            ...form1[key],
                            value: '',
                        };
                    }
                }

                if (selectedPortal && key === 'State') {
                    form1[key] = {
                        ...form1[key],
                        elementConfig : {
                            ...form1[key].elementConfig,
                            options: this.props.statesList? this.props.statesList.map((obj) => ({"value": obj.stateCode, "displayValue": obj.stateName+"("+obj.stateCode+")"})):[]
                        }
                    };
                }

                //Bank specific logic
                if (selectedPortal && selectedPortal.portalShortName === "CAP" && (key === "SubscriberId" || key === "SSN")) {
                    let elemKey = key === "SSN" ? "SubscriberId" : "SSN";
                    const elemValue = inputValue? inputValue: form1[key].value;
                    const elemKeyDisable = elemValue?true:false;

                    form1[elemKey] = {
                        ...form1[elemKey],
                        disabled: elemKeyDisable
                    };

                    form1[key] = {
                        ...form1[key],
                        label: key==="SubscriberId"? "Employee Id": form1[key].label,
                    };
                }
            }
        }

        //used for modify eligibility
        form1 = this.props.addFunctionSpecificData(form1, selectedPortal);

        let formValid = true;
        for(let key in form1 ){
            const validation = form1[key].value && form1[key].validation?checkValidity(form1[key].value, form1[key].validation): key === "UUID" || key === "targetPortal"?{isValid: true}:{isValid: false};
            formValid = formValid && validation.isValid;
            form1[key].valid = validation.isValid;
            // console.log("[Portal Form] buildForm validation ", key, form1[key], validation.isValid, formValid);
        }

        this.setState({formIsValid: formValid});

        // console.log("[Portal Form] buildForm end ", form1);
        return form1;
    }

    resetFormHandler = (event) =>{
        if(!(this.state.isSDKPortal || this.state.isPePortal)){
        // console.log("[AddAccount] clearFormData");
        event.preventDefault();
        // this.props.displayMessageHandler(null);
        this.setState({portalSpecificForm: this.props.resetFormHandler(this.state.portalSpecificForm, ["targetPortal"]) });
        }else{
            event.preventDefault();
            this.resetSdkFrom();
        }
    }

    resetSdkFrom = () =>{
        this.sdkPortalForm.resetForm();
    }

    getSdkFormData = (formData) => {
        return this.sdkPortalForm.getFormData(formData);
    }

    submitHandler = (event) => {
        event.preventDefault();

        let formData = this.getFormData();
        if(formData) {
            this.props.submitFormHandler(formData);
        }

    }

    getFormData = () => {
        let formData = {targetPortal: this.props.selectedPortal.portalShortName};
        if(!(this.state.isSDKPortal || this.state.isPePortal)){
        // console.log("[AddAccount] getFormData", this.state.portalForm );
        let invalidFields =[];
        // console.log("[AddAccount] getFormData: ", formData);

        for( let key in this.state.portalSpecificForm) {
            // console.log("[AddAccount] getFormData: portal form key value - %s : %s", key, this.state.portalSpecificForm[key].value);
            if(key !== "UUID" && !this.state.portalSpecificForm[key].value && !this.state.portalSpecificForm[key].disabled) {
                if((this.props.selectedPortal.portalShortName === 'MYUHC' || (this.props.selectedPortal.portalBrandName && this.props.selectedPortal.portalBrandName === 'MYUHC')) && key === 'ZipCode'){

                }else{
                    const fieldName = this.props.selectedPortal.portalShortName==="CAP" && key==="SubscriberId"?"Employee Id":this.state.portalForm[key].label;
                    invalidFields.push(fieldName);
                }
            } else {
                let value = key==="targetPortal"?this.props.selectedPortal.portalBrandName?this.props.selectedPortal.portalBrandName:this.props.selectedPortal.portalShortName:this.state.portalSpecificForm[key].value;
                key = (this.props.selectedPortal.portalShortName==="MYUHC" || (this.props.selectedPortal.portalBrandName && this.props.selectedPortal.portalBrandName === 'MYUHC')) && key==="MemberId" ? "SubscriberId" : key;
                formData = {
                    ...formData,
                    [key]: value
                };
            }
        }

        if(this.props.selectedPortal.portalShortName === "CAP" || this.props.selectedPortal.portalShortName === 'BSCA' || this.props.selectedPortal.portalShortName === 'HARVARDPILGRIM' || this.props.selectedPortal.portalShortName === 'MORGANWHITE'){
            formData = {
                ...formData,
                "uuid": this.props.memberInfo.essoData.uuid,
                "userName": this.props.memberInfo.essoData.userName
            }
        }

        const displayText = invalidFields.length>0?invalidFields.length===1?invalidFields.join(" ").concat(" field is required"):invalidFields.join(", ").concat(" fields are required"): null;

        // console.log("[Portal Form] getFormData: ", formData);
        // this.props.setDisplayMessage({type: "Error", info: {message:displayText}});
        this.props.displayMessageHandler({type: "Error", info: {message:displayText}});

        return invalidFields.length>0?null:formData;
    }else{
        let data = this.getSdkFormData(formData);
        return data;
    }
    }

    updateFormValidityState = (formIsValid) => {
        this.setState({
            ...this.state,
            formIsValid
        });
    }

    createPortalDropdownForSDK = (isSdkPortal) => {
        let targetPortalField =
          this.state.portalSpecificForm &&
          this.state.portalSpecificForm["targetPortal"]
            ? this.state.portalSpecificForm["targetPortal"]
            : this.state.portalForm["targetPortal"];
    
        return (
          <Input
            key="targetPortal"
            changed={(event) => this.inputChangedHandler(event, "targetPortal")}
            elementType={
              isSdkPortal
                ? targetPortalField.elementType
                : this.state.portalForm.targetPortal.elementType
            }
            elementConfig={
              isSdkPortal
                ? targetPortalField.elementConfig
                : this.state.portalForm.targetPortal.elementConfig
            }
            value={
              isSdkPortal
                ? targetPortalField.value
                : this.state.portalForm.targetPortal.value
            }
            disabled={
              isSdkPortal
                ? targetPortalField.disabled
                : this.state.portalForm.targetPortal.disabled
            }
            invalid={
              isSdkPortal
                ? !targetPortalField.valid
                : !this.state.portalForm.targetPortal.valid
            }
            shouldValidate={
              isSdkPortal
                ? targetPortalField.validation
                : this.state.portalForm.targetPortal.validation
            }
            touched={
              isSdkPortal
                ? targetPortalField.touched
                : this.state.portalForm.targetPortal.touched
            }
            label={
              isSdkPortal
                ? targetPortalField.label
                : this.state.portalForm.targetPortal.label
            }
            validateField={
              isSdkPortal
                ? targetPortalField.validation.required
                : this.state.portalForm.targetPortal.validation.required
            }
            inputType={
              isSdkPortal
                ? targetPortalField.inputType
                : this.state.portalForm.targetPortal.inputType
            }
          />
        );
      };

    uiIdentificationTypes = () => {
        let uiIds = this.props.selectedPortal.uiConfig.uiIdentificationTypes;
        if (this.state.isPePortal) {
            uiIds = uiIds.filter((uiId) => uiId.id !== 'ssnZipCode');
        }
        return uiIds;
    }

    render() {
        // console.log("[Portal Form] render", this.state.portalSpecificForm, this.props.message);
        // const showSpinner = this.props.loading || this.props.portalInfoLoading? <Spinner/>: null;
        const showSpinner = this.props.portalInfoLoading? <Spinner/>: null;

        let formsElementsArray = [];//[{id:'targetPortal', config: this.state.portalForm['targetPortal']}];
        for (let key in this.state.portalSpecificForm) {
          if ((AUTO_COMPLETE_SELECT_ENABLE && key !== "targetPortal") || !AUTO_COMPLETE_SELECT_ENABLE) {
            formsElementsArray.push({
              id: key,
              config: this.state.portalSpecificForm[key],
            });
          }
        }

        let buttons = null;
        if(this.props.selectedPortal) {
            buttons = (
                <div style={{display: "flex", justifyContent: "center"}}>
                    <Button id="reset" btnType="Cancel" clicked={this.resetFormHandler}>Cancel</Button>
                    <Button id="save" btnType="Search" disabled={!this.state.formIsValid}>{this.props.submitButtonLabel}</Button>
                </div>
            );
        }

        let mandatoryFieldsArray = []
        for(let key in this.state.dynamicPortalForm) {
            mandatoryFieldsArray.push({
                id: key,
                config: this.state.dynamicPortalForm[key]
            });
        }

        let targetPortalDropdown = null;
        if (!(this.state.isSDKPortal || this.state.isPePortal)) {
          targetPortalDropdown = (
            <div className={classes.TargetPortal}>
              {this.createPortalDropdownForSDK(false)}
            </div>
          );
        } else {
          targetPortalDropdown = (
            <div className={classes.TargetPortal}>
              {this.createPortalDropdownForSDK(true)}
            </div>
          );
        }

        let addAccountForm = null;
        if(!(this.state.isSDKPortal || this.state.isPePortal)){
            addAccountForm = (
            <form onSubmit={this.submitHandler}>
                <div>
                    {formsElementsArray.map(formElement => {
                        return (
                            <Input
                                key={formElement.id}
                                elementType={formElement.config.elementType}
                                elementConfig={formElement.config.elementConfig}
                                value={formElement.config.value}
                                disabled={formElement.config.disabled}
                                invalid={!formElement.config.valid}
                                shouldValidate={formElement.config.validation}
                                touched={formElement.config.touched}
                                label={formElement.config.label}
                                validateField={formElement.config?.validation?.required}
                                changed={(event) => this.inputChangedHandler(event, formElement.id)}
                                inputType={formElement.config.inputType}
                            />
                        )}       
                    )}
                    
                </div>
                {buttons}
            </form>
        );
        }else{
            addAccountForm = (
                <form onSubmit={this.submitHandler}>
                    { !AUTO_COMPLETE_SELECT_ENABLE && <div>{this.createPortalDropdownForSDK(true)}</div> }
                    <SdkPortalForm
                        uiIdentificationTypes={this.uiIdentificationTypes()}
                        isSDKPortal = {this.state.isSDKPortal || this.state.isPePortal}
                        selectedPortal = {this.props.selectedPortal}
                        memberInfo={this.props.memberInfo}
                        inputChangedHandler={this.inputChangedHandler}
                        displayMessageHandler={this.props.displayMessageHandler}
                        ref={sdkPortalForm => this.sdkPortalForm = sdkPortalForm}
                        updateFormValidityState={this.updateFormValidityState}
                        />
                {buttons}
                </form>);
        }

        

        const memberInfo = this.props.memberInfo?<MemberInfo memberInfo={this.props.memberInfo}/>:null;
        const userMessage = this.props.message!==null? <Message msgType={this.props.message.type} info={this.props.message.info} />: null;
        // console.log("[Portal Form] render: user message ", userMessage);

        return (
            <DisplayBox>
                <div className={classes.AddAccount}>
                    <h2 className={classes.FormTitle}>{this.props.formHeader}</h2>
                    <p className={classes.Message}>{this.props.formMessage}</p>
                    {userMessage}
                    {memberInfo}
                    {AUTO_COMPLETE_SELECT_ENABLE && targetPortalDropdown}
                    {addAccountForm}
                    {showSpinner}
                </div>
            </DisplayBox>
        );
    }
}

const mapStateToProps = state => {
    return {
        statesList: state.refData.states,
        disabledPortals: state.addEligibility.disabledPortals
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchStates: () => dispatch(actions.fetchStates()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DynamicPortalForm);
